/* GDP — couche canon / rails horizontaux (2026-08-06)
   Deuxieme moitie du correctif d amorce. La feuille gdp-canon-rails.css rend la
   carte suivante visible ; ce script fait en sorte qu elle soit DESSINEE.
   Sans lui, la carte 2 est bien a l ecran mais son image est en loading="lazy"
   et n arrive qu apres coup : le visiteur voit une zone vide a droite, ce qui
   annule tout le benefice de l amorce.
   On passe donc en eager les images des deux premieres cartes de chaque rail,
   et uniquement celles-la : les suivantes restent paresseuses, le cout reseau
   ne bouge pas. */
(function () {
  var RAILS = [
    '.gdp-amd-home__grid',
    '.gdp-assortment-decoder__grid',
    '.m2e-lo__crail',
    '.gdp-aq__flavors',
    '.h1m__grid'
  ];

  function prime(rail) {
    // Explicit server position: leave later home-section images under native lazy loading.
    if (rail.getAttribute('data-gdp-rail-loading') === 'lazy') return;
    var kids = rail.children, done = 0;
    for (var i = 0; i < kids.length && done < 2; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.width < 40) continue;
      done++;
      var imgs = kids[i].querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) {
        if (imgs[j].getAttribute('loading') === 'lazy') {
          imgs[j].setAttribute('loading', 'eager');
          imgs[j].setAttribute('fetchpriority', 'low');
          // relance le chargement si le navigateur avait deja tranche
          if (!imgs[j].complete) { var s = imgs[j].getAttribute('src'); if (s) imgs[j].setAttribute('src', s); }
        }
      }
    }
  }

  function run() {
    for (var k = 0; k < RAILS.length; k++) {
      var list = document.querySelectorAll(RAILS[k]);
      for (var i = 0; i < list.length; i++) {
        try { prime(list[i]); } catch (e) { }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
